import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type CurrentAdminService from 'garaje/services/current-admin';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import { AnalyticsEventNames } from 'garaje/utils/enums';

import type AnalyticsGlobalScheduledExportsController from './controller';

export default class AnalyticsGlobalScheduledExportsRoute extends Route {
  @service declare currentAdmin: CurrentAdminService;
  @service declare metrics: MetricsService;
  @service declare state: StateService;
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  afterModel(): void {
    this.logMetrics();
  }

  beforeModel(): void {
    if (this.abilities.cannot('visit-scheduled-exports global-analytic')) {
      this.router.transitionTo('unauthorized');
    }
  }

  logMetrics(): void {
    const {
      currentCompany: { id: companyId },
      visitorsSubscription,
      workplaceSubscription,
    } = this.state;

    const details = {
      companyId,
      app: visitorsSubscription?.app || workplaceSubscription?.app,
      plan: visitorsSubscription?.plan || workplaceSubscription?.plan,
      userId: this.currentAdmin?.id || '',
      employeeId: this.currentAdmin?.employee?.id || '',
    };
    this.metrics.trackEvent(AnalyticsEventNames.SCHEDULED_REPORTS_V2_GLOBAL_VISITED, details);
    this.metrics.logMonitorEvent(AnalyticsEventNames.SCHEDULED_REPORTS_V2_GLOBAL_VISITED, details);
  }

  setupController(controller: AnalyticsGlobalScheduledExportsController, model: void, transition: Transition): void {
    super.setupController(controller, model, transition);
    controller.showModal = false;
  }
}
